import {Logo} from '@logistics-frontend/blocks'
import {css} from '@logistics-frontend/blocks/theme/css'
import React from 'react'

import {Title} from './title'

const App: React.FC = () => (
  <>
    <p
      className={css`
        color: blue;
      `}
    >
      <Title />
    </p>
    <p
      className={css`
        background-color: yellow;
      `}
    >
      <Logo brand="yandex" lang="ru" />
    </p>
    <p
      className={css`
        color: gray;
      `}
    >
      {'<Content />'}
    </p>
  </>
)

export default App
